<template>
    <v-container fluid>
        <v-row>
            <v-col 
                style="padding: 10px;"
                cols="12"
                lg="2"
                md="3"
                sm="12"
            >
                <h3>Pipeline Construction - Front End</h3>
            </v-col>
            <v-col 
                style="padding-top: 10px; display: flex;"
                cols="12"
                lg="2"
                md="12"
                sm="12"
            >
                <v-combobox
                    v-model="sortSelected"
                    :items="listSortOptions"
                    label="Sort By"
                    item-text="description"
                    item-value="id"
                    clearable
                    outlined
                    @change="sortRegisters"
                    dense
                ></v-combobox>

                <v-tooltip bottom v-if="sortType == 0">
                    <template v-slot:activator="{ on }" v-if="sortType == 0">
                        <v-btn class="btnToogle" v-on="on" v-if="sortType == 0" @click="sortType = 1; sortRegisters()">
                            <v-icon>mdi-sort-ascending</v-icon>
                        </v-btn>
                    </template>
                    <span>Order by ascending</span>
                </v-tooltip>

                <v-tooltip bottom v-if="sortType == 1">
                    <template v-slot:activator="{ on }" v-if="sortType == 1">
                        <v-btn class="btnToogle" v-on="on" v-if="sortType == 1" @click="sortType = 0; sortRegisters()">
                            <v-icon>mdi-sort-descending</v-icon>
                        </v-btn>
                    </template>
                    <span>Order by descending</span>
                </v-tooltip>
            </v-col>
            <v-col 
                style="padding: 10px;"
                cols="12"
                lg="2"
                md="12"
                sm="12"
            >
                <v-combobox
                    :items="listUser"
                    label="Search by Supervisor"
                    item-text="name"
                    item-value="id"
                    multiple
                    clearable
                    single-line
                    outlined
                    dense
                ></v-combobox>
            </v-col>
            <v-col 
                style="padding: 10px;"
                cols="12"
                lg="2"
                md="12"
                sm="12"
            >
                <v-autocomplete
                    v-model="projectSelected"
                    :items="listProjects"
                    :loading="isLoading"
                    :search-input.sync="searchProject"
                    hide-selected
                    :no-data-text="textNoData"
                    item-text="description"
                    item-value="id"
                    placeholder="Card Search"
                    prepend-inner-icon="mdi mdi-magnify"
                    outlined
                    return-object
                    dense
                ></v-autocomplete>
            </v-col>
            <v-col 
                style="padding: 10px;"
                cols="12"
                lg="2"
                md="12"
                sm="12"
            >
                <v-form @submit.prevent="getRegisters">
                    <v-text-field
                        v-model="filter.fastSearch"
                        label="Filter Current View"
                        prepend-inner-icon="mdi mdi-filter"
                        outlined
                        single-line
                        @keyup="filteredSearch"
                        @click:prepend-inner="getRegisters"
                        dense
                    ></v-text-field>
                </v-form>
            </v-col>
            <v-col 
                style="padding-top: 10px; display: flex;"
                cols="12"
                lg="2"
                md="2"
                sm="12"
            >
                <v-combobox
                    v-model="daysRemaingSelected"
                    :items="listDaysRemaining"
                    label="Days Remaining"
                    item-text="description"
                    clearable
                    outlined
                    @change="filteredSearch"
                    dense
                ></v-combobox>
            </v-col>
        </v-row>

        <div id="divHeaders" style="width: 100%; overflow-x: auto" class="sticky" @scroll="syncScroll">

            <v-row 
                class="rowWrap"
            >
                <v-col 
                    v-for="(itemCard, index) in listCards" :key="index"
                    class="colWrap"
                    cols="12"
                    lg="2"
                    md="4"
                    sm="12"
                >
                    <v-card>
                        <v-card-title :class="`text-h6 lighten-2 pipelineTitle ${itemCard.cssClass}`">
                            <v-col 
                                cols="10"
                            >
                                <v-icon left class="pipelineWhiteColor">mdi mdi-card-text-outline</v-icon>
                                <label class="pipelineWhiteColor">{{ itemCard.title }}</label>
                            </v-col>
                            <v-col 
                                cols="2"
                                style="text-align: right;"
                            >
                                <label class="pipelineWhiteColor"> {{ itemCard.qtd }} </label>
                            </v-col>
                        </v-card-title>
                    </v-card>
                </v-col>

            </v-row>
        </div>

        <div id="divContents" style="width: 101%; overflow-x: auto" @scroll="syncScroll">
            <v-row 
                class="rowWrap"
            >
                <v-col 
                    v-for="(itemCard, index) in listCards" :key="index"
                    class="colWrap"
                    cols="12"
                    lg="2"
                    md="4"
                    sm="12"
                >   
                    <v-card 
                        class="pipelineDetails"
                        v-for="(itemProject, index) in itemCard.listItems" :key="index"
                    >
                        <ConstructionCard
                            :id="itemProject.id"
                            :itemProject="{...itemProject}"
                            :itemCard="{...itemCard}"
                            :firstStatus="PROJECT_STATUS.CONSTRUCTION_FRONTEND_DIGDEMO.id"
                            :lastStatus="PROJECT_STATUS.CONSTRUCTION_FRONTEND_BACKFILL.id"
                            :listStatusOriginal="listStatusOriginal"
                            :listConstructionActions="listConstructionActions"
                            :salesModule="salesModule"
                            :draftingModule="draftingModule"
                            :listContractor="listContractor"
                            :listConstructionPanel="listConstructionPanel"
                            :listConstructionStages="listConstructionStages"
                            :listUser="listUser"
                            :trackType="TRACK_TYPE.FRONTEND.id"
                            v-on:methodConfirmToCall="getRegisters()"
                        />
                    </v-card>
                    
                </v-col>

            </v-row>
        </div>
        
    </v-container>
</template>

<script>
    import Helpers from '@/utilities/Helpers';
    import { filterValuePart, orderBy } from '@/utilities/Utils';
    import ConstructionCard from "@/components/Services/ConstructionCard";
    import { 
        PROJECT_STATUS,
        CONSTRUCTION_PANEL,
        CONSTRUCTION_STAGE,
        TRACK_TYPE
    } from "@/utilities/Enums";
    import { filterByTrackStatus } from "@/utilities/TrackUtils";

    export default ({

        mixins: [Helpers],

        components: {
            ConstructionCard
        },

        data: () => ({

            filter: {
                fastSearch: ''
            },

            idPanel: CONSTRUCTION_PANEL.FRONTEND,
            listStages: CONSTRUCTION_STAGE,
            listUser: [],

            listCards:[],

            listDigDemo: [],
            listDigDemoFiltered: [],
            qtdDigDemo: 0,

            listFormSteel: [],
            listFormSteelFiltered: [],
            qtdFormSteel: 0,

            listInspection: [],
            listInspectionFiltered: [],
            qtdInspection: 0,

            listPrePlumb: [],
            listPrePlumbFiltered: [],
            qtdPrePlumb: 0,

            listGunite: [],
            listGuniteFiltered: [],
            qtdGunite: 0,

            listBackFill: [],
            listBackFillFiltered: [],
            qtdBackFill: 0,

            sortSelected: null,
            sortType: 0,
            listSortOptions: [
                { id: 1, description: 'Registration Date', listField: ['id'] },
                { id: 2, description: 'Deadline', listField: ['datePermittingStep1DeadlineDays', 'datePermittingStep2DeadlineDays', 'datePermittingStep3DeadlineDays', 'datePermittingStep4DeadlineDays', 'datePermittingStep4DeadlineDays'] },
                { id: 3, description: 'Responsible', listField: ['permitterUserName'] },
                { id: 4, description: 'Supervisor', listField: ['id'] },
                { id: 5, description: 'Contract Amount', listField: ['contractValue'] }
            ],
            textNoData: 'Type to search a project...',
            projectSelected: null,
            searchProject: null,
            listProjects: [],
            isLoading: false,

            daysRemaingSelected: null,
            listDaysRemaining: [],

            listStatusOriginal: [],
            listConstructionActions: [],
            salesModule: {},
            draftingModule: {},

            listContractor: [],
            listConstructionPanel: [],
            listConstructionStages: [],

            PROJECT_STATUS,
            TRACK_TYPE
        }),

        watch: {
            async searchProject(search) {
                
                if (search == null || search == undefined || search.toString().trim() == '') {
                    this.listProjects = [];
                    this.textNoData = "Type to search a project...";
                }
                else {

                    if (this.listProjects.length <= 0) {
                        this.textNoData = "No projects found";
                    }

                    this.isLoading = true;

                    this.listProjects = await this.$store.dispatch("serviceModule/ListProjectCompact", search);

                    this.isLoading = false;
                }
            }
        },

        methods: {

            filteredSearch() {

                const filter = this.filter.fastSearch.toLowerCase();                
                
                this.listCards.forEach(itemCard => {

                    itemCard.listItems = filterValuePart(itemCard.listItemsClone, filter, ['step', 'customerAddress', 'dateScopeWorkStep4Formatted', 'sellerName', 'customerName', 'nameProject', 'idFormatted']);

                    if (this.daysRemaingSelected != null && this.daysRemaingSelected != undefined) {
                        itemCard.listItems = filterValuePart(itemCard.listItems, this.daysRemaingSelected.description, ['dueDateDeadlineDays']);
                    }
                })

                return null;
            },

            sortRegisters() {

                let field = ['id'];

                if (this.sortSelected != null && this.sortSelected != undefined) {
                    field = this.sortSelected.listField;
                }
                
                this.listCards.forEach(itemCard => {

                    itemCard.listItems.sort((a, b) => { return orderBy(a, b, this.sortType, field[0]) });

                })
            },

            async getLists() {
                const listStatus = await this.$store.dispatch("serviceModule/ListStatus");
                this.listStatusOriginal = listStatus.sort((a, b) => { return orderBy(a, b, 0, 'id') });

                const listConstructionActions = await this.$store.dispatch("actionsModule/List");
                this.listConstructionActions = listConstructionActions.filter(act => act.status == 1);

                const listModules = await this.$store.dispatch("moduleModule/List");
                this.salesModule = listModules.filter(mod => mod.id == 1)[0];
                this.draftingModule = listModules.filter(mod => mod.id == 2)[0];

                this.listContractor = await this.$store.dispatch("contractorModule/List");
                this.listConstructionPanel = await this.$store.dispatch("serviceModule/ListConstructionPanel");
                this.listConstructionStages = await this.$store.dispatch("serviceModule/ListConstructionStages");
                
                const listUserResponse = await this.$store.dispatch("userModule/List");
                this.listUser = listUserResponse.filter(usr => usr.constructionSupervisor == 1);
            },

            async getRegisters() {

                this.showLoading();

                this.sortSelected = this.listSortOptions[0];

                const response = await this.$store.dispatch("serviceModule/ListPipelineConstruction", {
                    statusStart: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_DIGDEMO.id,
                    statusEnd: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_BACKFILL.id,
                    pool: 1,
                    bbq: 0,
                    pergola: 0
                });

                if (response != null && response != undefined) {

                    this.listCards = [];

                    if (response.listPipeline && response.listPipeline != null && response.listPipeline != undefined) {

                        this.listDigDemo = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_DIGDEMO.id, TRACK_TYPE.FRONTEND.id)];
                        if (this.listDigDemo != null && this.listDigDemo != undefined) {
                            this.qtdDigDemo = this.listDigDemo.length;
                        }
                        this.listDigDemoFiltered = [...this.listDigDemo];

                        this.listFormSteel = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_FORMSTEEL.id, TRACK_TYPE.FRONTEND.id)];
                        if (this.listFormSteel != null && this.listFormSteel != undefined) {
                            this.qtdFormSteel = this.listFormSteel.length;
                        }
                        this.listFormSteelFiltered = [...this.listFormSteel];


                        this.listInspection = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_FRONTENDINSPECTION.id, TRACK_TYPE.FRONTEND.id)];
                        if (this.listInspection != null && this.listInspection != undefined) {
                            this.qtdInspection = this.listInspection.length;
                        }
                        this.listInspectionFiltered = [...this.listInspection];


                        this.listPrePlumb = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_PREPLUMB.id, TRACK_TYPE.FRONTEND.id)];
                        if (this.listPrePlumb != null && this.listPrePlumb != undefined) {
                            this.qtdPrePlumb = this.listPrePlumb.length;
                        }
                        this.listPrePlumbFiltered = [...this.listPrePlumb];


                        this.listGunite = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_GUNITE.id, TRACK_TYPE.FRONTEND.id)];
                        if (this.listGunite != null && this.listGunite != undefined) {
                            this.qtdGunite = this.listGunite.length;
                        }
                        this.listGuniteFiltered = [...this.listGunite];


                        this.listBackFill = [...filterByTrackStatus(response.listPipeline, this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_BACKFILL.id, TRACK_TYPE.FRONTEND.id)];
                        if (this.listBackFill != null && this.listBackFill != undefined) {
                            this.qtdBackFilistBackFill = this.listBackFill.length;
                        }
                        this.listBackFillFiltered = [...this.listBackFill];

                        const listPipelines = [...this.listDigDemoFiltered,
                                                ...this.listFormSteelFiltered,
                                                ...this.listInspectionFiltered, 
                                                ...this.listPrePlumbFiltered,
                                                ...this.listGuniteFiltered,
                                                ...this.listBackFillFiltered
                                              ];

                        const listDaysRemaining = listPipelines.map(item => { return { description: item.dueDateDeadlineDays } } );

                        this.listDaysRemaining = [...new Set(listDaysRemaining.sort((a, b) => { return orderBy(a, b, 1, 'description') }))];

                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_DIGDEMO.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_DIGDEMO.id,
                            qtd: this.listDigDemo.length,
                            listItems: this.listDigDemo,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: this.listStages.FRONTEND_DIGDEMO,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: false,
                                workOrder: false,
                                workOrderRequest: false,
                                inspection: false,
                                showAdvanceButton: true,
                                showBackButton: false,
                            },
                        })
                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_FORMSTEEL.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_FORMSTEEL.id,
                            qtd: this.listFormSteel.length,
                            listItems: this.listFormSteel,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: this.listStages.FRONTEND_FORMSTEEL,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: true,
                                workOrder: true,
                                workOrderRequest: true,
                                inspection: true,
                                showAdvanceButton: true,
                                showBackButton: true
                            },
                        })
                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_FRONTENDINSPECTION.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_FRONTENDINSPECTION.id,
                            qtd: this.listInspection.length,
                            listItems: this.listInspection,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: this.listStages.FRONTEND_FRONTENDINSPECTION,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: true,
                                workOrder: true,
                                workOrderRequest: true,
                                inspection: true,
                                showAdvanceButton: true,
                                showBackButton: true
                            },
                        })
                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_PREPLUMB.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_PREPLUMB.id,
                            qtd: this.listPrePlumb.length,
                            listItems: this.listPrePlumb,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: this.listStages.FRONTEND_PREPLUMB,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: true,
                                workOrder: true,
                                workOrderRequest: true,
                                inspection: true,
                                showAdvanceButton: true,
                                showBackButton: true
                            },
                        })
                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_GUNITE.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_GUNITE.id,
                            qtd: this.listGunite.length,
                            listItems: this.listGunite,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: this.listStages.FRONTEND_GUNITE,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: true,
                                workOrder: true,
                                workOrderRequest: true,
                                inspection: true,
                                showAdvanceButton: true,
                                showBackButton: true
                            },
                        })
                        
                        this.listCards.push({
                            title: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_BACKFILL.description,
                            idStatusCard: this.PROJECT_STATUS.CONSTRUCTION_FRONTEND_BACKFILL.id,
                            qtd: this.listBackFill.length,
                            listItems: this.listBackFill,
                            cssClass: 'colorPipeline',
                            showSelectSupervisor: false,
                            idPanel: this.idPanel, 
                            idStage: this.listStages.FRONTEND_BACKFILL,
                            moreOptions: {
                                jobSpecifics: true,
                                hold: true,
                                workOrder: true,
                                workOrderRequest: true,
                                inspection: true,
                                showAdvanceButton: true,
                                showBackButton: true
                            },
                        })
                
                        this.listCards.forEach(itemCard => {

                            itemCard.listItemsClone = [...itemCard.listItems];

                        });
                    }
                }

                this.hideLoading();
            },
        },

        async created() {
            await this.getLists();
            await this.getRegisters();
        },
    })
</script>

<style scoped>

    .colorPipeline {
        background-color: var(--color__construction_dashboard_frontend);
    }

    .v-progress-linear__determinate {
        background-color: var(--color__construction_dashboard_frontend) !important; 
    }
</style>